module.exports = __webpack_public_path__ + "media/images/error_fisherman-378fc668c471acf6a04d6791f0575715.svg";